export default __webpack_public_path__ + "static/media/floor-16.8fcda380.jpg";